<p-dialog
    [(visible)]="visible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '52rem', maxWidth: '95vw' }"
    [contentStyle]="{ maxHeight: 'calc(100vh - 16rem)' }"
    header="Cómo funciona la respuesta automática"
    (onHide)="cerrar()"
>
    <h6 class="ayuda-titulo ayuda-titulo--primero">Los cuatro tipos de paso</h6>
    <div class="ayuda-tipos">
        <div *ngFor="let tipo of tipos">
            <strong>{{ tipo.label }}</strong>
            <span>{{ tipo.ayuda }}</span>
        </div>
    </div>

    <h6 class="ayuda-titulo">Cinco formas de armarlo</h6>

    <p-accordion>
        <p-accordionTab header="1. Cada botón va directo a su destino">
            <div class="ayuda-caso">
                <div class="ayuda-chat">
                    <div class="ayuda-bub ayuda-bub--bot">
                        Hola {{ '{{1}}' }}, su cuota {{ '{{2}}' }} venció el {{ '{{3}}' }}.
                        <div class="ayuda-chips">
                            <span>Regularizar</span><span>Promesa de pago</span>
                        </div>
                    </div>
                    <div class="ayuda-bub ayuda-bub--cli">Regularizar</div>
                    <div class="ayuda-bub ayuda-bub--bot">Perfecto. En un momento le escribe un asesor.</div>
                    <div class="ayuda-sys">cae en la bandeja</div>
                </div>
                <ol class="ayuda-pasos">
                    <li><b>Regularizar</b> → Crear la respuesta → <b>Pasar a una persona</b>.</li>
                    <li><b>Promesa de pago</b> → Crear la respuesta → <b>Cerrar la conversación</b>.</li>
                    <li>Escribí el mensaje de cada uno. Listo.</li>
                </ol>
            </div>
        </p-accordionTab>

        <p-accordionTab header="2. Preguntar algo más antes de derivar">
            <div class="ayuda-caso">
                <div class="ayuda-chat">
                    <div class="ayuda-bub ayuda-bub--cli">Promesa de pago</div>
                    <div class="ayuda-bub ayuda-bub--bot">
                        ¿Cuándo podría abonar?
                        <div class="ayuda-chips">
                            <span>Esta semana</span><span>Este mes</span><span>No puedo aún</span>
                        </div>
                    </div>
                    <div class="ayuda-bub ayuda-bub--cli">Esta semana</div>
                    <div class="ayuda-bub ayuda-bub--bot">Registrado. Un asesor lo contacta.</div>
                    <div class="ayuda-sys">queda registrado: «Esta semana»</div>
                </div>
                <ol class="ayuda-pasos">
                    <li><b>Promesa de pago</b> → Crear la respuesta → <b>Preguntar con botones</b>.</li>
                    <li>Agregá sus botones. Cada uno abre una pregunta nueva en la lista de pendientes.</li>
                    <li>Dos botones pueden ir al mismo lugar: usá <b>Llevar a un paso que ya existe</b>.</li>
                </ol>
            </div>
        </p-accordionTab>

        <p-accordionTab header="3. Mandar un aviso y después cerrar">
            <div class="ayuda-caso">
                <div class="ayuda-chat">
                    <div class="ayuda-bub ayuda-bub--cli">Sí, enviármelo</div>
                    <div class="ayuda-bub ayuda-bub--bot">Enseguida se lo enviamos al correo registrado.</div>
                    <div class="ayuda-bub ayuda-bub--bot">Si no le llega, escríbanos y lo revisamos.</div>
                    <div class="ayuda-sys">conversación cerrada</div>
                </div>
                <ol class="ayuda-pasos">
                    <li>Crear la respuesta → <b>Enviar un mensaje</b>.</li>
                    <li>Ese paso no espera nada, así que pide <b>con qué paso sigue</b>: apuntalo a un <b>Cerrar la conversación</b>.</li>
                </ol>
            </div>
        </p-accordionTab>

        <p-accordionTab header="4. Derivar con el motivo ya cargado">
            <div class="ayuda-caso">
                <div class="ayuda-chat">
                    <div class="ayuda-bub ayuda-bub--bot">
                        ¿Sobre qué necesita hablar?
                        <div class="ayuda-chips">
                            <span>Mi cuota</span><span>Mi tarjeta</span><span>Otro tema</span>
                        </div>
                    </div>
                    <div class="ayuda-bub ayuda-bub--cli">Mi tarjeta</div>
                    <div class="ayuda-bub ayuda-bub--bot">Lo comunicamos con el área de tarjetas.</div>
                    <div class="ayuda-sys">el asesor abre la conversación sabiendo el motivo</div>
                </div>
                <ol class="ayuda-pasos">
                    <li>Los tres botones van a <b>Pasar a una persona</b>.</li>
                    <li>Un texto distinto por motivo: el registro guarda lo que el cliente vio, y así se distingue cada rama.</li>
                </ol>
            </div>
        </p-accordionTab>

        <p-accordionTab header="5. Un menú con «volver»">
            <div class="ayuda-caso">
                <div class="ayuda-chat">
                    <div class="ayuda-bub ayuda-bub--bot">
                        Su saldo es {{ '{{2}}' }}. ¿Algo más?
                        <div class="ayuda-chips">
                            <span>Volver al menú</span><span>Listo, gracias</span>
                        </div>
                    </div>
                    <div class="ayuda-bub ayuda-bub--cli">Volver al menú</div>
                    <div class="ayuda-sys">vuelve al primer paso</div>
                </div>
                <ol class="ayuda-pasos">
                    <li><b>Volver al menú</b> → <b>Llevar a un paso que ya existe</b> → <b>Primer paso</b>.</li>
                    <li>Se puede volver en círculo, siempre que desde cada paso haya al menos un botón que lleve a cerrar la conversación o a una persona.</li>
                </ol>
            </div>
        </p-accordionTab>
    </p-accordion>

    <ng-template pTemplate="footer">
        <button pButton type="button" label="Entendido" class="p-button-text" (click)="cerrar()"></button>
    </ng-template>
</p-dialog>
